import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TopBar from './component/TopBar';

const DigiSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  return (
    <div className="app-page">
      <TopBar title="Verification" backPath={`/Permission?id=${id}`} />

      <div className="app-content">
        <div className="app-card" style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
          <p style={{ fontSize: 20, fontWeight: 700, color: '#1d2e77', marginBottom: 8 }}>
            Verified Successfully
          </p>
          <p style={{ fontSize: 14, color: '#666', marginBottom: 32 }}>
            Your Aadhaar has been successfully verified.
          </p>
          <button className="btn-primary-app" style={{ marginBottom: 0 }} onClick={() => navigate(`/DocumentUpload?applicationId=${id}&customerId=${id}`)}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default DigiSuccess;
